import React, { useState, useEffect } from 'react';
import './Home.css';
import airCooler from '../../../assets/cool_breeze.png';
import exhaustFans from '../../../assets/exhaust_pic.png';
import hvlsFans from '../../../assets/hvls_png.png';
import airhandling from '../../../assets/air_handling.png';
import skylight from '../../../assets/sky_light.png';
import rackings from '../../../assets/rackings.jpeg';
import materialhandling from '../../../assets/material_handling.png';
import xlpe from '../../../assets/xlpe.png';
import busbar from '../../../assets/busbar_system.png';
import { Link } from 'react-router-dom';


// Background image links for each product
const backgroundImages = {
  'Air Cooler': 'https://img.freepik.com/premium-photo/air-conditioner-units-hvac-roof-industrial-building-with-blue-sky-clouds-background_505557-7226.jpg',
  'Exhaust Fans': 'https://www.shutterstock.com/image-photo/close-industrial-exhaust-fan-ventilation-260nw-2133956175.jpg',
  'HVLS Fans': 'https://freerangestock.com/sample/73682/dark-tunnel-leading-into-the-unknown.jpg',
  'Air Handling Unit': 'https://png.pngtree.com/background/20230426/original/pngtree-the-ceiling-is-very-dark-and-the-air-conditioning-unit-is-picture-image_2483217.jpg',
  'Sky Light': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVO2nJIvLGoXDeK7vMf75_wLgZUJ43Q3Ze4g&s',
  'Rackings': 'https://www.heubelshaw.com/-/media/dealers/heubelshaw/pallet-rack/1440x488-a4-rack.jpg?rev=8303c1534de94c13b723a88c28293279&h=488&w=1440&la=en&hash=DE4163ED1D16A9920691DF53C74EAAF4',
  'Material Handling': 'https://t3.ftcdn.net/jpg/02/48/51/04/360_F_248510414_82sctvdCGOcgwzneviTGhI0EBZoIVjFU.jpg',
  'XLPE Insulation': 'https://freerangestock.com/sample/73682/dark-tunnel-leading-into-the-unknown.jpg',
  'Busbar Systems': 'https://circuitglobe.com/wp-content/uploads/2016/07/electrical-bus-bars.jpg'
};

const images = [
  { url: airCooler, text: 'Air Cooler', quote: "Cooling comfort crafted for you – because fresh air is the essence of vitality." },
  { url: exhaustFans, text: 'Exhaust Fans', quote: "Ventilate, rejuvenate – breathe easy with the power of circulation." },
  { url: hvlsFans, text: 'HVLS Fans', quote: "Creating calm in expansive spaces – high volume, low speed, pure efficiency." },
  { url: airhandling, text: 'Air Handling Unit', quote: "Precision in airflow, comfort in every corner – engineered to perfect indoor environments." },
  { url: skylight, text: 'Sky Light', quote: "Bringing nature’s light indoors – illuminating spaces with the warmth of daylight." },
  { url: rackings, text: 'Rackings', quote: "Strong, versatile storage – organizing your world with dependable solutions." },
  { url: materialhandling, text: 'Material Handling', quote: "Streamlining logistics – built to move your business forward." },
  { url: xlpe, text: 'XLPE Insulation', quote: "High-performance insulation – safeguarding connections with resilience and reliability." },
  { url: busbar, text: 'Busbar Systems', quote: "Efficient power distribution – engineered for peak performance and safety." }
];
const Home = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isDragging, setIsDragging] = useState(false); // State to track if dragging

  const [fadeClass, setFadeClass] = useState('fade-in'); // To trigger the text fade-in animation

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeClass('fade-out'); // Trigger fade-out before changing the image
      setTimeout(() => {
        setCurrentImage((prevImage) => (prevImage + 1) % images.length);
        setFadeClass('fade-in'); // Trigger fade-in after image change
      }, 1000); // Wait for fade-out to complete before changing
    }, 9000); // Change every 9 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);


  const nextImage = () => {
    setCurrentImage((prevImage) => (prevImage + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prevImage) => (prevImage - 1 + images.length) % images.length);
  };

  // Handlers for showing/hiding arrows during drag
  const handleDragStart = () => {
    setIsDragging(true); // Show arrows
  };

  const handleDragEnd = () => {
    setIsDragging(false); // Hide arrows
  };

  const currentProduct = images[currentImage];
  const backgroundImage = backgroundImages[currentProduct.text];

  return (
    <div
      className="home-container"
      onMouseDown={handleDragStart}
      onMouseUp={handleDragEnd}
      onMouseMove={handleDragStart} 
      onMouseLeave={handleDragEnd} 
      onTouchStart={handleDragStart}
      onTouchEnd={handleDragEnd}
    >
      <div
        className="background-image-wrapper"
        style={{
    backgroundImage: `url(${backgroundImage})`,
    transition: 'background-image 1s ease-in-out'
  }}
      ></div>
      <div className={`text-container ${fadeClass}`}>
        <div
          className={`arrow left-arrow ${isDragging ? 'visible' : ''}`}
          onClick={prevImage}
        >
          &#8592;
        </div>
        
        <h3 className="custom-heading">Sustainable Solutions for a Smart Future</h3>
        <h1 className="company-name">{currentProduct.text}</h1>
        <div className="tagline">{currentProduct.quote}</div>
        <div className="button-container">
          <button className="product-button">Our Products</button>
          <Link to="/contacts">  {/* Add this Link component to handle navigation */}
    <button className="contact-button">Contact Us</button>
  </Link>
        </div>
      </div>

      {/* Image carousel */}
      <div className="image-container">
        {images.map((image, index) => (
          <div
            key={index}
            className={`image-carousel ${index === currentImage ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image.url})` }}
          />
        ))}

        {/* Right arrow */}
        <div
          className={`arrow right-arrow ${isDragging ? 'visible' : ''}`}
          onClick={nextImage}
        >
          &#8594;
        </div>
      </div>

      {/* Dot indicators */}
      <div className="dot-container">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentImage ? 'active' : ''}`}
            onClick={() => setCurrentImage(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Home;


